import i18n from 'i18next';
import getSharedConfig from './sharedConfig';

const getI18n = locale =>
  i18n.init({
    ...getSharedConfig(locale),
    initImmediate: false
  });

export default getI18n;
